import { skillsList } from "constants/skills";

const initialState = {
  skillsList: {},
};

const skills = (state = initialState, action) => {
  switch (action.type) {
    case skillsList:
      return { ...state, skillsList: action.payload };

    default:
      return state;
  }
};

export default skills;